// extracted by mini-css-extract-plugin
export default {"login__root":"login_login__root__ijjaa","login__tenant-logo":"login_login__tenant-logo__8PQX6"};